/*
 * Pilloft – "Maak er 4 van" in de winkelwagen (lade en pagina).
 * Vervangt één winkelwagenregel door de variant "4 stuks" van hetzelfde product,
 * en laat Horizon de winkelwagen opnieuw opbouwen via het standaard cart-event.
 * Lukt dat niet, dan herladen we de pagina zodat de klant altijd de juiste stand ziet.
 *
 * Daarnaast: een lege winkelwagenlade gaat niet mee naar de volgende pagina.
 * Horizon onthoudt open lades in sessionStorage ('theme-drawer-open') en zet ze op brede
 * schermen weer open naast de pagina. Bij een lege lade halen we 'cart-drawer' uit die lijst
 * voordat de pagina wordt verlaten, zodat "Je winkelwagen is leeg" niet op elke pagina blijft staan.
 * Hetzelfde bij een klik op Afrekenen of een snelle betaalknop: wie terugkomt uit de checkout,
 * krijgt de lade niet opnieuw open op elke pagina.
 */
if (!window.plCartUpgradeReady) {
  window.plCartUpgradeReady = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function forgetEmptyCartDrawer() {
    const inner = document.querySelector('#cart-drawer .cart-drawer__inner');
    if (!inner || !inner.classList.contains('cart-drawer--empty')) return;
    forgetCartDrawer();
  }

  function forgetCartDrawer() {
    try {
      const key = 'theme-drawer-open';
      const ids = (sessionStorage.getItem(key) || '').split(',').filter(Boolean);
      if (!ids.includes('cart-drawer')) return;
      const rest = ids.filter((id) => id !== 'cart-drawer');
      if (rest.length) sessionStorage.setItem(key, rest.join(','));
      else sessionStorage.removeItem(key);
    } catch (error) {
      /* sessionStorage niet beschikbaar: niets te doen */
    }
  }

  window.addEventListener('pagehide', forgetEmptyCartDrawer);

  // Naar de checkout (Afrekenen of een snelle betaalknop): de lade niet open laten staan
  // als de klant daarna terugkomt in de winkel.
  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      if (
        target.closest(
          '[name="checkout"], a[href*="/checkout"], .shopify-payment-button, shopify-accelerated-checkout, shopify-accelerated-checkout-cart'
        )
      ) {
        forgetCartDrawer();
      }
    },
    true
  );

  async function refreshCart(cart, variantId) {
    try {
      const { CartLinesUpdateEvent } = await import('@shopify/events');
      const deferred = CartLinesUpdateEvent.createPromise();
      document.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'update',
          context: 'cart',
          lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + variantId, quantity: 1 }],
          promise: deferred.promise,
        })
      );
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, source: 'pl-upgrade', didError: false },
      });
    } catch (error) {
      window.location.reload();
    }
  }

  document.addEventListener('click', async (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-pl-upgrade]') : null;
    if (!button || button.disabled) return;
    event.preventDefault();

    const label = button.textContent;
    button.disabled = true;
    button.textContent = 'Even geduld';

    const updates = {};
    updates[button.dataset.key] = 0;
    updates[button.dataset.variant] = 1;

    try {
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates }),
      });
      if (!response.ok) throw new Error('cart update failed');
      const cart = await response.json();
      await refreshCart(cart, button.dataset.variant);
    } catch (error) {
      button.disabled = false;
      button.textContent = label;
      window.location.reload();
    }
  });
}
